import React from 'react';

const TemplatePermissionResult = ({
  allContainers,
  userRoles,
  templateRoles,
  allowOverwrite,
}) => {
  const usersContainers = userRoles.map((r) => r.container_id);
  const templateContainers = templateRoles.map((r) => r.container_id);
  const determineResult = (cID) => {
    let willUpdate = false;
    let willCreate = false;
    let prevRole;
    let role;
    if (usersContainers.includes(cID)) {
      let uRole = userRoles.find((r) => r.container_id == cID).role;
      if (templateContainers.includes(cID) && allowOverwrite) {
        let tRole = templateRoles.find((r) => r.container_id == cID).role;
        if (uRole == tRole) {
          // no change, returns current userRole
          role = uRole;
        } else {
          role = tRole;
          prevRole = uRole;
          willUpdate = true;
        }
      } else {
        // no change, returns current userRole
        role = uRole;
      }
    } else {
      // will be added by Template Role
      role = templateRoles.find((r) => r.container_id == cID).role;
      willCreate = true;
    }
    return { role, willCreate, willUpdate, prevRole };
  };
  const resultingContainerRoles = allContainers.map((container) => {
    let preview = determineResult(container.id);
    // preview = { role: 'STRING', willChange: boolean, willUpdate: boolean, prevRole: 'string' };
    return { ...container, ...preview };
  });

  return (
    <>
      {resultingContainerRoles.map((container) => (
        <li
          key={`container-${container.id}`}
          className={container.active ? '' : 'inactive'}
        >
          <div className='name'>{container.name}</div>
          {container.willCreate && (
            <div style={{ color: 'green' }}>
              <strong>(NEW)</strong> {container.role}
            </div>
          )}

          {container.willUpdate && (
            <div style={{ color: 'red' }}>
              <strong>UPDATE</strong> from '{container.prevRole}' to '
              {container.role}'
            </div>
          )}

          {!container.willCreate && !container.willUpdate && (
            <div>{container.role} (no change)</div>
          )}
        </li>
      ))}
    </>
  );
};

export default TemplatePermissionResult;
